<template>
  <div class="app-container" v-if="form">
    <el-form ref="formRef" :model="form" :rules="rules" label-width="160px" label-position="left">
      <el-card shadow="hover" class="form-card">
        <el-row :gutter="20">
          <el-col :span="24" v-for="field in fields" :key="field.prop">
            <el-form-item :label="field.label" :prop="field.prop">
              <el-input v-if="field.type !== 'select'" v-model="form[field.prop]" :placeholder="'请输入' + field.label"
                style="width: 300px;" maxlength="50" show-word-limit />
              <el-select v-else-if="field.type === 'select'" v-model="form[field.prop]"
                :placeholder="'请选择' + field.label" style="width: 300px;">

                <el-option v-for="option in plateOptions" :key="option.id" :label="option.moduleName"
                  :value="option.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
    </el-form>

    <!-- 短剧列表 -->
    <el-card shadow="hover" class="drama-section">
      <div class="section-title">关联短剧</div>
      <el-button type="primary" icon="el-icon-plus" @click="openDramaDialog">添加短剧</el-button>

      <el-table :data="form.dramas" border style="margin-top: 20px">
        <el-table-column prop="id" label="短剧ID" width="120" />
        <el-table-column prop="videoName" label="短剧名称" />
        <el-table-column prop="categorySort" label="排序" width="151">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.categorySort" :min="1" :max="9999" :step="1" :precision="0" size="small"
              @blur="handleSortBlur(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column prop="coverUrl" label="短剧封面" width="120">
          <template slot-scope="scope">
            <el-image :src="scope.row.coverUrl" class="drama-cover" fit="cover" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="removeDrama(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 提交按钮 -->
    <div class="submit-footer">
      <el-button type="primary" @click="handleSubmit" :disabled="form.dramas.length === 0">提交</el-button>
    </div>

    <!-- 短剧选择弹窗 -->
    <el-dialog title="选择短剧" :visible.sync="dramaDialogVisible" width="800px">
      <el-form :inline="true" :model="dramaSearch" class="mb-2">
        <el-form-item label="短剧ID">
          <el-input v-model="dramaSearch.id" placeholder="输入ID" size="small"
            @input="dramaSearch.id = dramaSearch.id.replace(/\D/g, '')" />
        </el-form-item>
        <el-form-item label="短剧名称">
          <el-input v-model="dramaSearch.name" placeholder="输入短剧名称" size="small" />
        </el-form-item>
        <el-form-item label="短剧标签">
          <el-select v-model="dramaSearch.type" placeholder="选择分类" size="small" style="width: 150px;">
            <el-option label="全部" value="" />
            <el-option label="无" value="0" />
            <el-option label="new" value="1" />
            <el-option label="hot" value="2" />
            <el-option label="首播" value="3" />
            <el-option label="独播" value="4" />
          </el-select>
        </el-form-item>
        <el-form-item label="短剧分类">
          <el-select v-model="dramaSearch.tagIds" multiple placeholder="选择短剧标签" size="small" style="width: 250px;">
            <el-option v-for="tag in videoTags" :key="tag.id" :label="tag.tagTitle" :value="tag.id" />
          </el-select>
        </el-form-item>
        <el-button type="primary" size="small" @click="loadDramaList">搜索</el-button>
        <el-button size="small" @click="resetDramaSearch">重置</el-button>
      </el-form>

      <el-table :data="availableDramas" @selection-change="handleDramaSelect" border>
        <el-table-column type="selection" width="55" />
        <el-table-column prop="id" label="短剧ID" width="100" />
        <el-table-column prop="videoName" label="短剧名称" />
        <el-table-column prop="coverUrl" label="封面" width="120">
          <template slot-scope="scope">
            <el-image :src="scope.row.coverUrl" fit="cover" style="width: 60px; height: 60px;" />
          </template>
        </el-table-column>

        <el-table-column prop="type" label="短剧标签" width="80">
          <template slot-scope="scope">
            <span>
              {{
                scope.row.type === 0 ? '无'
                  : scope.row.type === 1 ? 'new'
                    : scope.row.type === 2 ? 'hot'
                      : scope.row.type === 3 ? '首播'
                        : scope.row.type === 4 ? '独播'
                          : ''
              }}
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="tagIds" label="短剧分类" />
      </el-table>

      <el-pagination style="margin-top: 10px; text-align: right" layout="total, prev, pager, next"
        :total="dramaPagination.total" :current-page="dramaPagination.page" :page-size="dramaPagination.pageSize"
        @current-change="handleDramaPageChange" />

      <span slot="footer" class="dialog-footer">
        <el-button @click="dramaDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAddDrama">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      form: {
        id: null,
        categoryNameCn: '',
        categoryNameTraditional: '',
        categoryNameEn: '',
        categoryNameBm: '',
        categoryNameIn: '',
        coefficientId: '',
        dramas: []
      },
      rules: {
        categoryNameCn: [
          { required: true, message: '请输入简体中文栏目名', trigger: 'blur' },
          { validator: this.validateChinese, trigger: 'blur' }
        ],
        categoryNameTraditional: [
          { required: true, message: '请输入繁体中文栏目名', trigger: 'blur' },
          { validator: this.validateChinese, trigger: 'blur' }
        ],
        categoryNameEn: [
          { required: true, message: '请输入英文栏目名', trigger: 'blur' },
          { validator: this.validateEnglish, trigger: 'blur' }
        ],
        categoryNameBm: [
          { required: true, message: '请输入马来栏目名', trigger: 'blur' },
          { validator: this.validateMalay, trigger: 'blur' }
        ],
        categoryNameIn: [
          { required: true, message: '请输入印尼栏目名', trigger: 'blur' },
          { validator: this.validateIndonesian, trigger: 'blur' }
        ],
        coefficientId: [
          { required: true, message: '请选择所属板块', trigger: 'change' }
        ]
      },
      fields: [
        { label: '简体中文栏目名', prop: 'categoryNameCn' },
        { label: '繁体中文栏目名', prop: 'categoryNameTraditional' },
        { label: '英文栏目名', prop: 'categoryNameEn' },
        { label: '马来栏目名', prop: 'categoryNameBm' },
        { label: '印尼栏目名', prop: 'categoryNameIn' },
        { label: '所属板块', prop: 'coefficientId', type: 'select' }
      ],
      plateOptions: [],
      isEdit: false,
      dramaDialogVisible: false,
      availableDramas: [],
      selectedDramas: [],
      videoTags: [],
      dramaSearch: { id: '', name: '', type: '', tagIds: [] },
      dramaPagination: { page: 1, pageSize: 10, total: 0 }
    }
  },
  computed: {
    ...mapState('category', ['editCategory'])
  },
  created() {
    const id = this.$route.params.id
    this.fetchPlateList().then(() => {
    if (id) {
      this.isEdit = true

      this.fetchCategoryDetail(id).then(() => {
        const detail = this.editCategory
        this.form = {
          id: detail.id,
          categoryNameCn: detail.categoryNameCn || '',
          categoryNameTraditional: detail.categoryNameTraditional || '',
          categoryNameEn: detail.categoryNameEn || '',
          categoryNameBm: detail.categoryNameBm || '',
          categoryNameIn: detail.categoryNameIn || '',
          coefficientId: detail.coefficientId ? Number(detail.coefficientId) : '',
          dramas: (detail.dramas || []).map((d, i) => ({
            ...d,
            categorySort: d.categorySort || i + 1
          }))
        };
      });
    }
    });
  },
  methods: {
    ...mapActions('category', ['fetchCategoryDetail', 'clearEditCategory']),

    // 获取板块列表接口
    async fetchPlateList() {
      try {
        const res = await request.get('/video/module/list');
        // 适配后端CommonResponse格式
        if (res.success) {
          this.plateOptions = res.data || []; // 或res.data.data（根据实际返回）
        } else {
          this.plateOptions = [];
        }
        console.log('板块数据：', this.plateOptions); // 调试查看数据结构
      } catch (error) {
        console.error('获取板块列表失败：', error);
        this.$message.error('加载板块数据失败，请稍后重试');
      }
    },
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (!valid) {
          this.$message.error('请检查表单信息')
          return
        }
        if (this.form.dramas.length === 0) {
          this.$message.error('请至少选择一个短剧')
          return
        }

        // 排序重复及正整数校验
        const sortSet = new Set()
        for (const drama of this.form.dramas) {
          if (!drama.categorySort || isNaN(drama.categorySort) || drama.categorySort < 1) {
            this.$message.error('短剧排序必须为正整数')
            return
          }
          if (sortSet.has(drama.categorySort)) {
            this.$message.error('短剧排序不能重复')
            return
          }
          sortSet.add(drama.categorySort)
        }

        const payload = {
          ...this.form,
          videoList: this.form.dramas.map(d => ({ videoId: d.id, categorySort: d.categorySort }))
        }
        const url = this.isEdit ? '/platform/category/update' : '/platform/category/add'
        request.post(url, payload)
          .then(() => {
            this.$message.success('保存成功')
            this.clearEditCategory()
            this.$router.push('/category/category')
          })
          .catch(() => {
            this.$message.error('提交失败')
          })
      })
    },
    openDramaDialog() {
      this.dramaDialogVisible = true
      this.loadVideoTags()
      this.loadDramaList()
    },
    loadDramaList() {
      const params = {
        pageNum: this.dramaPagination.page,
        pageSize: this.dramaPagination.pageSize,
        id: this.dramaSearch.id,
        videoName: this.dramaSearch.name,
        type: this.dramaSearch.type,
        tagIdList: this.dramaSearch.tagIds
      }
      request.get('/video/videos/page', { params }).then(res => {
        this.availableDramas = res.data?.records || []
        this.dramaPagination.total = res.data.total || 0
      })
    },
    handleDramaSelect(val) {
      this.selectedDramas = val
    },
    confirmAddDrama() {
      const existingIds = new Set(this.form.dramas.map(d => d.id))
      const newItems = this.selectedDramas.filter(d => !existingIds.has(d.id)).map((d, i) => ({
        ...d,
        categorySort: this.form.dramas.length + i + 1
      }))
      this.form.dramas.push(...newItems)
      this.dramaDialogVisible = false
    },
    resetDramaSearch() {
      this.dramaSearch = { id: '', name: '', type: '', tagIds: [] }
      this.loadDramaList()
    },
    handleDramaPageChange(page) {
      this.dramaPagination.page = page
      this.loadDramaList()
    },
    removeDrama(index) {
      this.form.dramas.splice(index, 1)
    },
    loadVideoTags() {
      request.get('/video/video-tags/page', { params: { pageNum: 1, pageSize: 100 } }).then(res => {
        this.videoTags = res.data?.records || []
      })
    },
    // 允许：中文 + 数字 + 空格 + 各种符号
    validateChinese(rule, value, callback) {
      const regex = /^[\u4e00-\u9fa5\d\s\p{P}\p{S}]+$/u
      if (!value) {
        callback(new Error('请输入内容'))
      } else if (!regex.test(value)) {
        callback(new Error('请输入中文、数字或符号'))
      } else {
        callback()
      }
    },

// 允许：英文 + 数字 + 空格 + 各种符号
    validateEnglish(rule, value, callback) {
      const regex = /^[A-Za-z\d\s\p{P}\p{S}]+$/u
      if (!value) {
        callback(new Error('请输入内容'))
      } else if (!regex.test(value)) {
        callback(new Error('请输入英文、数字或符号'))
      } else {
        callback()
      }
    },

// 允许：马来文（按英文字母算） + 数字 + 空格 + 各种符号
    validateMalay(rule, value, callback) {
      const regex = /^[A-Za-z\d\s\p{P}\p{S}]+$/u
      if (!value) {
        callback(new Error('请输入内容'))
      } else if (!regex.test(value)) {
        callback(new Error('请输入马来文、数字或符号'))
      } else {
        callback()
      }
    },

// 允许：印尼文（按英文字母算） + 数字 + 空格 + 各种符号
    validateIndonesian(rule, value, callback) {
      const regex = /^[A-Za-z\d\s\p{P}\p{S}]+$/u
      if (!value) {
        callback(new Error('请输入内容'))
      } else if (!regex.test(value)) {
        callback(new Error('请输入印尼文、数字或符号'))
      } else {
        callback()
      }
    },
    handleSortBlur(row) {
      if (!row.categorySort || isNaN(row.categorySort) || row.categorySort < 1) {
        this.$set(row, 'categorySort', 1) // 若为空、非数字或小于1，赋值为1
      }
    }

  },
  beforeDestroy() {
    this.clearEditCategory()
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
  background: #fff;
}

.section-title {
  font-weight: bold;
  margin-bottom: 10px;
}

.drama-cover {
  width: 60px;
  height: 60px;
  border-radius: 4px;
}

.submit-footer {
  margin-top: 30px;
  text-align: right;
}
</style>
